export default __webpack_public_path__ + "static/media/phoneIcon.b5e00d7f.svg";